module.exports = __webpack_public_path__ + "media/promo/courses/images/structbg-5f89ba9e993d20f0c2620e42f3ff0322.jpg";